export const extractPhoneNumber = (url: string) => {
  const urlParams = new URLSearchParams(url.split('?')[1]);
  const link = urlParams.get('link');
  if (link && link.startsWith('tel:')) {
    return link.replace('tel:', '').replace(/[^0-9-]/g, '');
  }
  return null;
};
